import { style } from '@vanilla-extract/css';

import { paragraph } from '../paragraph/Paragraph.css';

export const linkElement = style({
  selectors: {
    // override global style
    [`&, ${paragraph} &`]: {
      fontWeight: 'var(--wt-inline-link-font-weight)',
      fontStyle: 'var(--wt-inline-link-font-style)',
      textDecorationLine: 'var(--wt-inline-link-underline)',
      textDecorationColor:
        'var(--wt-inline-link-underline-color-override, var(--post-content-inline-link-color, var(--wt-inline-link-underline-color)))',
      color: 'var(--wt-inline-link-color-override, var(--post-content-inline-link-color, var(--wt-inline-link-color)))',
    },
  },
});
